/* tslint:disable */
/* eslint-disable */
import { NgModule, ModuleWithProviders, SkipSelf, Optional } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { BookingApiConfiguration, BookingApiConfigurationParams } from './booking-api-configuration';

import { BookingAdminService } from './services/booking-admin.service';
import { BookingHealthFindrService } from './services/booking-health-findr.service';
import { BookingMedicalAdvisorService } from './services/booking-medical-advisor.service';

/**
 * Module that provides all services and configuration.
 */
@NgModule({
  imports: [],
  exports: [],
  declarations: [],
  providers: [
    BookingAdminService,
    BookingHealthFindrService,
    BookingMedicalAdvisorService,
    BookingApiConfiguration
  ],
})
export class BookingModule {
  static forRoot(params: BookingApiConfigurationParams): ModuleWithProviders<BookingModule> {
    return {
      ngModule: BookingModule,
      providers: [
        {
          provide: BookingApiConfiguration,
          useValue: params
        }
      ]
    }
  }

  constructor( 
    @Optional() @SkipSelf() parentModule: BookingModule,
    @Optional() http: HttpClient
  ) {
    if (parentModule) {
      throw new Error('BookingModule is already loaded. Import in your base AppModule only.');
    }
    if (!http) {
      throw new Error('You need to import the HttpClientModule in your AppModule! \n' +
      'See also https://github.com/angular/angular/issues/20575');
    }
  }
}
